<template>
  <b-modal
      id="servicesCopyModal"
      ref="modal"
      :title="$t('Copy services')"
      no-close-on-backdrop
      size="xl"
      @close="selectedWalls = []"
  >
    <b-form @submit.prevent="handleSubmit">
      <walls-tree-select
          v-model="form.walls"
          :errors="form.errors"
          :project-id="+projectId"
          error-prefix="walls"
      />

      <input hidden type="submit">
    </b-form>

    <template #modal-footer>
      <submit-button :pending="form.busy" class="mr-auto" @click="handleSubmit" />
    </template>
  </b-modal>
</template>
<script>
import SubmitButton from "@/components/SubmitButton";
import WallsTreeSelect from "@/components/selects/WallsTreeSelect";
import Form from 'vform';

export default {
  name: 'ServicesCopy',
  components: {WallsTreeSelect, SubmitButton},
  props: {
    projectId: {
      type: [Number, String],
      required: true
    },
    wallId: {
      type: [Number, String],
      required: true
    },
    wallName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      form: new Form({
        walls: [],
      }),
      lazy: true,
    }
  },
  computed: {
    apiUrl() {
      return `/api/projects/${this.projectId}/walls`
    }
  },
  methods: {
    handleSubmit() {
      if (this.form.busy) return;

      this.form
          .post(`/api/walls/${this.wallId}/services/duplicate`)
          .then(() => {
            this.savedToast();
            this.form.reset();
            this.$refs.modal.hide();
          })
          .catch(e => e.response || throw e)
    },
  }
}
</script>
